// extracted by mini-css-extract-plugin
export default {"Title":"EventContentHeader-module-e8eb220cdc213edd4a87"};